/* eslint-disable class-methods-use-this */
import React from 'react';
import { t } from 'i18next';
import { CircularProgress } from '@material-ui/core';
import { Modal, Button } from '@workboard/wobo-ui';
import { withTranslation } from 'react-i18next';

class WorkdayConfigModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      tenant: '',
      baseUrl: '',
      modalLoadState: 'loading', // loading | saving | syncing | form
    };
  }

  componentDidMount() {
    fetch('/wb/integration/getWorkdayConfig')
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          const { config } = data;
          this.setState({
            username: config.username,
            password: config.password,
            tenant: config.tenant,
            baseUrl: config.baseUrl,
            workdayConnected: config.workdayConnected,
          });
        }
        this.setState({ modalLoadState: 'form' });
      })
      .catch((error) => {
        this.setState({ modalLoadState: 'form' });
        console.error('Error fetching Workday config:', error);
        toastr.error(t('Error fetching Workday config'));
      });
  }

  WorkdaySubmitConfig = (e) => {
    e.preventDefault();
    this.setState({ modalLoadState: 'saving' });
    const { username, password, tenant, baseUrl } = this.state;
    const { onDismiss } = this.props;
    fetch('/wb/integration/setWorkdayConfig', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        config: {
          username,
          password,
          tenant,
          baseUrl,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ modalLoadState: 'form' });
        if (data.status === 'error') {
          toastr.error(t('Error saving configuration.'));
        } else if (!data.config.workdayConnected) {
          toastr.error(t('Invalid Configuration.'));
          this.setState({ workdayConnected: false });
        } else {
          // declare success and close the modal
          toastr.success(t('Configuration saved. Workday connected.'));
          onDismiss();
        }
      })
      .catch((error) => {
        this.setState({ modalLoadState: 'form' });
        console.error('Error saving Workday config:', error);
        toastr.error(t('Error saving Workday configuration.'));
      });
  };

  WorkdaySyncNow = (e) => {
    e.preventDefault();
    toastr.info(t('Syncing Workday... be back soon!'));
    this.setState({ modalLoadState: 'syncing' });
    fetch('/wb/integration/doWorkdaySync', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ modalLoadState: 'form' });
        data?.taskSummary?.forEach((message) => {
          toastr.success(message.split(' ').slice(0, 24).join(' '));
        });
      });
  };

  render() {
    const { t } = this.props;
    const { isOpen, onDismiss } = this.props;
    const { modalLoadState, workdayConnected, username, password, tenant, baseUrl } = this.state;

    const loading = (
      <div>
        <CircularProgress /> {t('Fetching existing configuration')} ...
      </div>
    );

    const saving = (
      <div>
        <CircularProgress /> {t('Saving and testing configuration')} ...
      </div>
    );

    const syncing = (
      <div>
        <CircularProgress /> {t('Performing sync')} ...
      </div>
    );

    const form = (
      <form onSubmit={this.WorkdaySubmitConfig} id="workdayConfigForm">
        <style>
          {'.many-button { margin: 0 10px }'}
          {'.form-control { width: 95% }'}
        </style>
        <div className="form-group" style={{ display: workdayConnected ? 'none' : 'flex', justifyContent: 'center' }}>
          <Button type="button" className="btn btn-error many-button">
          {t('This configuration is not valid')}
          </Button>
        </div>

        <div className="kpis-content">
          <div className="form-group">
            <label htmlFor="username">
              {t('Username')}
              <input
                type="text"
                id="username"
                className="form-control"
                value={username}
                onChange={(e) => this.setState({ username: e.target.value })}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="password">
              {t('Password')}
              <input
                type="password"
                id="password"
                className="form-control"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="tenant">
              {t('Tenant')}
              <input
                id="tenant"
                type="text"
                className="form-control"
                value={tenant}
                onChange={(e) => this.setState({ tenant: e.target.value })}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="baseUrl">
              {t('Base Url')}
              <textarea
                id="baseUrl"
                className="form-control"
                value={baseUrl}
                onChange={(e) => this.setState({ baseUrl: e.target.value })}
              />
            </label>
          </div>
          <div className="form-group" style={{ display: 'none', justifyContent: 'center' }}>
            <Button type="button" onClick={this.WorkdaySyncNow} className="btn btn-primary many-button">
              {t('Sync Now')}
            </Button>
          </div>
        </div>
      </form>
    );

    const body = () => {
      switch (modalLoadState) {
        case 'loading':
          return loading;
        case 'saving':
          return saving;
        case 'syncing':
          return syncing;
        default:
          return form;
      }
    };

    return (
      <Modal
        title="Configure Workday Integration"
        isOpen={isOpen}
        onDismiss={onDismiss}
        onSubmit={this.WorkdaySubmitConfig}
        submitLabel="Save Config"
        className="wobo-user-integration-modal"
        data-testid="wobo-user-integration-modal-test-id"
      >
        <div className="wobo-user-integration-modal-inner" style={{ width: '600px' }}>
          {body()}
        </div>
      </Modal>
    );
  }
}

export default withTranslation()(WorkdayConfigModal);
